import React, { useEffect, useRef, useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FilterIcon from '@mui/icons-material/FilterListRounded';
import IconButton from '@mui/material/IconButton';
import type { TConversationsFilter } from 'src/services/api/messages/use-conversations-search';
import FilterModal, { type FilteringBy } from 'src/pages/landlord/conversations/components/header/ConversationsFilterModal';
import Responsive from 'src/components/responsive';
import { useMobile } from 'src/theme/responsive';

type Props = {
    isFilterOpen: boolean;
    setFilterOpen: (open: boolean) => void;
    filter: TConversationsFilter;
    inboxFilters?: TConversationsFilter;
    properties: Array<any>;
    setFilter: (newFilter: Partial<TConversationsFilter>) => void;
    resetFilter: () => void;
    disabledFilters?: FilteringBy[];
}
export default function ConversationsFilterButton({ isFilterOpen, setFilterOpen, filter, inboxFilters, properties, setFilter, resetFilter, disabledFilters }: Props) {
    const buttonRef = useRef<HTMLButtonElement>(null);

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const isMobile = useMobile();
    useEffect(() => {
        if (!isFilterOpen) {
            setAnchorEl(null);
        }
    }, [isFilterOpen]);

    useEffect(() => {
        setAnchorEl(null);
    }, [isMobile]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setFilterOpen(true);
    };

    return (
        <>
            <Responsive mobile>
                <IconButton
                    ref={buttonRef}
                    onClick={handleClick} edge="end"
                >
                    <FilterIcon />
                </IconButton>
            </Responsive>
            <Responsive desktop>
                <Button
                    ref={buttonRef}
                    color="dark"
                    startIcon={<FilterIcon />}
                    onClick={handleClick}
                    data-testid="filter-button"
                >
                    <Typography mt={0.25} variant="body2">Filter</Typography>
                </Button>
            </Responsive>


            <FilterModal
                anchorEl={anchorEl ?? buttonRef.current}
                isFilterOpen={isFilterOpen}
                setFilterOpen={setFilterOpen}
                filter={filter}
                inboxFilters={inboxFilters}
                properties={properties}
                setFilter={setFilter}
                resetFilter={resetFilter}
                disabledFilters={disabledFilters}
            />
        </>
    );
}
